<style scoped="scoped">
	*{
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}
  .cloudGoodsManageBox{
    width:1440px;
    height:auto;
    margin:0 auto;
    padding:30px 0;
  }
  .cloudGoodsManageTagList{
    width:auto;
    height:30px;
    display: flex;
    align-items:center;
  }
  .cloudGoodsManageTag{
    line-height: 32px;
    margin-right:25px;
    cursor: pointer;
    width: 120px;
    height: 32px;
    background: #FFFFFF;
    border-radius: 4px;
    
    
  }
  .cloudGoodsManageTag:hover{
    border:1px solid rgb(99, 118, 247);
  }
  .cloudGoodsManageBox .meng{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
    background: rgba(51, 51, 51, 0.51);
  }
  
  /* .gzh_box{
    margin-top: 50px;
  }
  .gzh_box>div:nth-child(2){
    margin-top: 40px;
  } */
</style>

<template>
	<div class='cloudGoodsManageBox'>
    <div class='cloudGoodsManageTagList' v-if='!fromClient'>
      <div :style='now==item ? "border:1px solid rgb(99, 118, 247);":"boxShadow: 0px 3px 6px rgba(119, 119, 119, 0.16);"' v-for='item in tags' class='cloudGoodsManageTag' @click='changeNow(item)' >{{item}}</div>
    </div>
    <plank ref='plank' v-if='now=="板材"' @addProduct="addProduct" @dataSet='dataSet'></plank>
    <hardware ref='hardware' v-if='now=="五金"'></hardware>
    <edge ref="edge" v-if='now == "封边"'></edge>
    <door ref="door" v-if="now == '柜门'"></door>
    <other ref="other" v-if="now == '其他'"></other>
    <album ref="album" v-show="now == '画册' || now =='色卡'" :albumType="albumType"></album>
    <vrScene ref="vrScene" v-if="now == 'VR场景'"></vrScene>
    <model ref="model" v-if="now == '模型'"></model>
    <cabinet ref="cabinet" v-if="now == '柜体'"></cabinet>
    <woodenDoor ref="woodenDoor" v-if="now == '木门'"></woodenDoor>
    <shutter ref="shutter" v-if="now == '门窗'"></shutter>
    <furniture ref="furniture" v-if="now == '家具'"></furniture>
    <div class="meng" v-if="AddProductShow"></div>
    <AddProduct v-if="AddProductShow" @addProduct="addProduct"></AddProduct>
    <DataSet v-if="dataSetShow" @dataSet='dataSet'></DataSet>

    <!-- <div v-show="now != '板材'" class="gzh_box">
      <div>
        <img src="../../assets/guigui_gzh.jpg" alt="">
      </div>
      <div>
        <span>关注公众号，在手机上添加</span>
      </div>
    </div> -->
  </div>
</template>

<script>
  import plank from '../../components/cloud/cloudGoodsManage/plank.vue'
  import hardware from '../../components/cloud/cloudGoodsManage/hardwareManage/hardware'
  import edge from '../../components/cloud/cloudGoodsManage/edgeManage/edge'
  import door from '../../components/cloud/cloudGoodsManage/doorManage/door'
  import other from '../../components/cloud/cloudGoodsManage/otherManage/other'
  import album from '../../components/cloud/cloudGoodsManage/albumManage/album'
  import AddProduct from '../../components/cloud/AddProduct'
  import DataSet from '../../components/cloud/BasicDataSet'
  import vrScene from '../../components/cloud/cloudGoodsManage/vrSceneManage/vrScene'
  import model from '../../components/cloud/cloudGoodsManage/modelManage/model'
  import cabinet from '../../components/cloud/cloudGoodsManage/cabinetManage/cabinet'
  import shutter from '../../components/cloud/cloudGoodsManage/shutterManage/shutter'
  import furniture from '../../components/cloud/cloudGoodsManage/furnitureManage/furniture'
  import woodenDoor from '../../components/cloud/cloudGoodsManage/woodenDoorManage/woodenDoor'
	export default {
		components:{
        plank,
        hardware,
        edge,
        door,
        other,
        album,
        AddProduct,
        DataSet,
        vrScene,
        model,
        cabinet,furniture,woodenDoor,shutter
		},
		props:[],
		data() {
			return {
        now:'板材',
        tags:['板材','封边','五金','柜门','其他','画册','色卡','VR场景','模型','柜体','木门','门窗','家具'],
        AddProductShow:false,
        dataSetShow:false,
        albumType: ''
			}
		},
		computed: {
       fromClient(){
         return this.$store.state.fromClient
       }
		},
		mounted() {

		},
		methods: {
      changeNow(now){
       /*  return */
        this.now=now
        if(now == '画册'){
          // this.$refs.album.changeType(0)
          this.albumType = now;
        }else if(now == '色卡'){
          // this.$refs.album.changeType(1)
          this.albumType = now;
        }
      },
      addProduct(value){
        this.AddProductShow = value
        if(!value){
          // 添加成功后刷新商品列表
          this.$refs.plank.refreshList()
        }
      },
       dataSet(value){
        // console.log('2222222222222',value)
        this.dataSetShow = value
      }
		}
	}
</script>
